import actions from './actions'
const initialState = {
  joinTask : false,
  cancelTask: false,
  infoTask: false,
  moveTask: false,
};

export default function modalReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state
  }
}
